<template>
    <div class="container">
        <div class="containerBox">
            <div class="handle-box">
                <!-- <el-input v-model="select_word" placeholder="请输入用户名" clearable class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button> -->
               <el-button type="primary" icon="el-icon-plus" @click="addRole">新增子账号</el-button>
            </div>
            
            <l-table
                :list="accountList"
                :total="total" 
                :otherHeight="230"
                :options="options"
                :pagination="pagination"
                :columns="columns" 
                :operates="operates"
                @handleSizeChange="handleSizeChange"
                @handleIndexChange="handleIndexChange">
            </l-table>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog :title="dialogTitle" :visible.sync="editVisible" width="40%" :before-close="dialogClose">
            <el-form ref="roleForm" class="roleForm" :rules="rules" :model="form" label-width="100px">
                <el-form-item label="账户名称" prop="username">
                    <el-input v-model="form.username"></el-input>
                </el-form-item>
                <el-form-item label="账户密码" prop="password" v-if="!form.oid">
                    <el-input type="password" v-model="form.password"></el-input>
                </el-form-item>
                <el-form-item label="姓名" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="mobile">
                    <el-input v-model="form.mobile"></el-input>
                </el-form-item>
                <el-form-item label="权限分组" prop="group" v-if="showgroup">
                    <el-select v-model="form.group" placeholder="请选择权限分组">
                        <el-option
                            v-for="item in groupList"
                            :key="item.OID"
                            :label="item.Groupname"
                            :value="item.OID">
                        </el-option>
                    </el-select>
                </el-form-item>
<!--                <el-form-item label="项目管理" prop="projects">
                    <el-select v-model="form.projects" multiple placeholder="请选择项目管理">
                        <el-option
                            v-for="(item,index) in projectList"
                            :key="index"
                            :label="item.projectname"
                            :value="item.oid">
                        </el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item label="子系统管理" prop="projects">
                    <el-select v-model="form.projects" multiple placeholder="请选择子系统管理">
                        <el-option
                            v-for="(item,index) in projectList"
                            :key="index"
                            :label="item.project_system_name"
                            :value="item.oid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="账户状态" prop="enable">
                    <el-select v-model="form.enable" placeholder="请选择账户状态">
                        <el-option label="可用" :value="true"></el-option>
                        <el-option label="禁用" :value="false" :disabled="isshow"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="LOGO" prop="company_logo">
                    <el-upload class="avatar-uploader" 
                        :action="UploadUrl" 
                        :show-file-list="false" 
                        accept="image/*" 
                        :on-success="handleAvatarSuccess" 
                        :on-progress="uploadVideoProcess"
                        :headers="headers"
                        name="image"
                        :before-upload="beforeAvatarUpload" style="text-align: left">
                        <img v-if="!Logo" :src="form.company_logo" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <el-progress v-if="videoUploadPercent>0 && videoUploadPercent<100" type="circle" width="50" :percentage="videoUploadPercent" class="upload-progress"></el-progress>
                    </el-upload>
                </el-form-item>
                <el-form-item label="账户职责">
                    <el-input v-model="form.description"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import Service from '@/api/Service'
import {$Alert} from '@/utils/utils'
import Storage from '@/utils/storage'
import config from '@/config'
import lTable from '@/components/lTable/lTable'
import stringUtils from '@/utils/stringUtils'
import { mapGetters } from "vuex";
const jsSHA = require("jssha");

export default {
    name: "role",
    inject: ["reload"],
    data() {
        const checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("电话号码不能为空"));
            } else {
                if (stringUtils(value).isMobilePhone() || stringUtils(value).isTelPhone()) {
                    callback();
                } else {
                     return callback(new Error("电话号码格式有误"));
                }
            }
        };
        return {
            select_word: "",
            editVisible: false, // 编辑弹框
			showgroup:true,//是否显示权限分组
            form: {
                projects: [],
            }, //  编辑框表单内容
            dialogTitle: "",
            groupList: [],  //  权限分组
            projectList: [], // 项目列表
			isshow:true,
            // 编辑框验证规则
            rules: {
                username: [
                    {
                        required: true,
                        message: "请输入账户名称",
                        trigger: "blur"
                    }
                ],
                password: [
                    {
                        required: true,
                        message: "请输入账户密码",
                        trigger: "blur"
                    }
                ],
                name: [
                    {
                        required: true,
                        message: "请输入使用者姓名",
                        trigger: "blur"
                    }
                ],
                group: [
                    {
                        required: true,
                        message: "请选择账户角色",
                        trigger: "change"
                    }
                ],
                projects: [
                    {
                        required: true,
                        message: "请选择管理子系统",
                        trigger: "change"
                    }
                ],
                enable: [
                    { required: true, message: "请选择账户状态", trigger: "change" }
                ],
                mobile: [
                    {
                        required: true,
                        trigger: "blur",
						validator: checkPhone 
                    }
                ],
            },
            UploadUrl: config.UPLOAD_URL,
            videoUploadPercent: 0,
            Logo: true,

            // 表格栏
            total: 0,
            accountList: [],
            pagination: {
                page_num: 1,
                page_sum: 10
            }, 
            columns: [
                {
                    prop: 'username',
                    label: '账户名称',
                    align: 'center',
                },
                {
                    prop: 'name',
                    label: '姓名',
                    align: 'center',
                },
                {
                    prop: 'group',
                    label: '权限分组',
                    align: 'center',
                    formatter: (row, column, cellValue) => {
                        return this.fmtGroup(row)
                    }
                },
                {
                    prop: 'project',
                    label: '管理项目',
                    align: 'center',
                },
                {
                    prop: 'enable',
                    label: '使用状态',
                    align: 'center',
                    sortable: true,
                    render: (h, params) => {
                        return h('el-tag', {
                            props: {type: params.row.enable ? 'success' : 'danger' } // 组件的props
                        }, params.row.enable ? '正常' : '禁用')
                    },
                },
                {
                    prop: 'description',
                    label: '账户职责',
                    align: 'center',
                    sortable: true,
                },
            ], // 需要展示的列
            operates: {
                width: 260,
                fixed: 'right',
                list: [
                    {
                        label: '修改',
                        type: 'primary',
                        show: (index, row) => {
                            return true
                        },
                        icon: 'el-icon-edit',
                        plain: true,
                        disabled: (index, row) => {
                            return false
                        },
                        method: (index, row) => {
                            this.handleEdit(row)
                        }
                    },
                    {
                        label: '删除',
                        type: 'danger',
                        show: (index, row) => {
                            return true
                        },
                        icon: 'el-icon-delete',
                        plain: true,
                        disabled: (index, row) => {
                            return false
                        },
                        method: (index, row) => {
                            this.handleDelete(row)
                        }
                    },
                    {
                        label: '密码重置',
                        type: 'warning',
                        show: (index, row) => {
                            return true
                        },
                        icon: '',
                        plain: true,
                        disabled: (index, row) => {
                            return false
                        },
                        method: (index, row) => {
                            this.handleChangePwd(row)
                        }
                    },
                ]
            }, // 操作按钮组
            options: {
                stripe: true, // 是否为斑马纹 table
                loading: false, // 是否添加表格loading加载动画
                highlightCurrentRow: true, // 是否支持当前行高亮显示
                mutiSelect: false // 是否支持列表项选中功能
            }, // table 的参数
        };
    },
    computed: {
        // 项目，项目列表
        ...mapGetters(['baseData', "user"]),
        headers() {
            let token = Storage.get('token');
            if (token) {
                return { Authorization: token.token };
            }else{
                return {}
            }
        },
    },
    components: { lTable },
    mounted() {
        this.getData();
        this.getRoleList();
        this.getProjectList();
    },
    methods: {
        // 搜索
        search() {
            console.log(this.select_word);
        },
        // 获取账号列表
        async getData() {
            let params = Object.assign({}, this.pagination, {usertype: 4});
            let data = await Service.getAccountList(params);
            if(data) {
               let list = data.list == null ? [] : data.list;
                if(list.length>0) {
                    list.map(v=>{
                        // let arr = JSON.parse(v.project_id_json);
						let arr =v.project_id_json;
                        if(arr.length == 1) {
                            v.project = arr[0].projectname
                        }else{
                            v.project = arr.reduce(function(a, b){
                                return b.projectname + '、' + a;
                            }, "")
                        }
                    })
                }
                this.accountList = list;
                this.total = data.total;
            }
        },
        // 切换页码
        handleSizeChange (pagination) {
            this.pagination = pagination
            this.getData()
        },
        // 切换页码
        handleIndexChange (pagination) {
            this.pagination = pagination
            this.getData()
        },
        // 获取角色列表
        async getRoleList() {
            let assigned_user_id = this.user.oid;
            let data = await Service.getRoleGroupList({assigned_user_id: assigned_user_id});
            data = data =='success' ? [] : data;
            if(data.length>0) {
               this.groupList = data;
            }
			// for(var i = 0; i<this.groupList.length;i++){
			// 	console.log(this.groupList[i].OID)
			// }
        },
        // 获取项目列表
      //   async getProjectList() {
      //       let res = await Service.getProjectList({
      //           projectname: '',
      //           province: '',
      //           city: '',
      //           dist: '',
      //           salename: '',
      //           page_num: 1,
      //           page_sum: 100
      //       });
      //       let data = res.list === null ? [] : res.list;
      //       if(data.length>0) {
      //          this.projectList = data;   
      //       }
      //   },
        async getProjectList() {
            let res = await Service.getProjectSystemList();
            let data = res === null ? [] : res;
            if(data.length>0) {
               this.projectList = data;
            }

        },
        dialogClose(done) {  
            done();
			// this.$refs["roleForm"].resetFields();
        },
        // 新增用户
        addRole() {
			this.isshow = true;
            this.editVisible = true;
			this.Logo = true;
            this.dialogTitle = "新增";
            this.form = {
                projects: [],
            };
        },
        // 编辑用户
        handleEdit(row) {
			this.isshow = false;
            this.editVisible = true;
			
            this.dialogTitle = "编辑";
            // let projects = JSON.parse(row.project_id_json).map(v=>{
            //     return v.assigned_project_id
            // })
            let projects =row.project_id_json.map(v=>{
                return v.assigned_project_id
            })
			
            this.form = {
                username: row.username,
                enable: row.enable,
                name: row.name,
                mobile: row.mobile,
                group: row.group,
                projects: projects,
                description: row.description,
                oid: row.oid,
                usertype: row.usertype
            }
			for(var i=0;i<this.groupList.length;i++){
				if(this.groupList[i].OID == this.form.group){
					this.showgroup = true
					break
				}else{
					this.showgroup = false
				}
			}
			// if(this.groupList.includes(this.form.group)){
			// 	this.showgroup = true
			// }else{
				
			// }
			if(row.company_logo != ""){
				this.form.company_logo = row.company_logo
				this.Logo = false;
			}	
        },
        handleDelete(data) {
            $Alert(`是否确认删除 ${data.username} `).then( async (bool)=>{
                if(bool){
                    let res = await Service.delAccount({oid: data.oid});
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.reload();
                    }
                }
           });
        },
        // 重置密码
        handleChangePwd(row) {
            $Alert(`是否确认重置${row.username}账号密码，确认重置后密码默认为654321！`).then( async (bool)=>{
                if(bool){
                    const psw = "654321";
                    let shaObj = new jsSHA("SHA-512", "TEXT");
                    shaObj.update(psw);
                    let params = {};
                    params.oid = row.oid;
                    params.password = shaObj.getHash("HEX");
                    let res = await Service.editPwd(params);
                    if(res) {
                        this.$message({
                            type: 'success',
                            message: '操作成功!',
                            duration: 1500,
                        });
                        this.reload();
                    }
                }
           });
            
        },
        // 保存编辑
        saveEdit() {
            this.$refs["roleForm"].validate( valid => {
                if (valid) {
                    if(this.form.oid) {
                        // 编辑
                        this.editAcount()
                    } else{
                        // 添加
                        this.addAcount()
                    }
                } else {
                    return false;
                }
            });
        },
        async addAcount() {
            // 密码加密
            let shaObj = new jsSHA("SHA-512", "TEXT");
            shaObj.update(this.form.password);

            let project_id_json = this.form.projects.map(v => {
                let obj = {}
                for (let i = 0; i < this.projectList.length; i++) {
                    const item = this.projectList[i];
                    if(item.oid === v){
                        obj.assigned_project_id = v;
                        obj.projectname = item.project_system_name
                    }
                }
                return obj
            })
            this.form.pwd = shaObj.getHash("HEX");
            this.form.project_id_json = JSON.stringify(project_id_json)
			// this.form.project_id_json = project_id_json
            this.form.usertype = 4;
            let data = await Service.AddAccount(this.form);
            if(data) {
                this.$message({
                    type: 'success',
                    message: '操作成功!',
                    duration: 1500,
                });
                this.reload();
                this.editVisible = false;
            }
        },
        async editAcount() {
            let project_id_json = this.form.projects.map(v => {
                let obj = {}
                for (let i = 0; i < this.projectList.length; i++) {
                    const item = this.projectList[i];
                    if(item.oid === v){
                        obj.assigned_project_id = v;
                        obj.projectname = item.project_system_name
                    }
                }
                return obj
            })
            this.form.project_id_json = JSON.stringify(project_id_json);
			// this.form.project_id_json = project_id_json;
            let data = await Service.editAccount(this.form);
            if(data) {
                this.$message({
                    type: 'success',
                    message: '操作成功!',
                    duration: 1500,
                });
                this.reload();
                this.editVisible = false;
            }
        },
		
        // 权限分组
        fmtGroup(row) {
            let obj = this.groupList.filter(v=>{
                return v.OID === row.group
            })
            if(!obj[0]) return ""
            return obj[0].Groupname;
        },
        // 图片上传成功后返回地址
        handleAvatarSuccess(res) {
			this.Logo = true;
            this.form.company_logo = config.DEFAULT_FILE_PATH + res.data;
            this.Logo = false;
        },
        uploadVideoProcess(event, file, fileList){
            this.videoUploadPercent = file.percentage.toFixed(0);
        },
        // 上传LOGO
        beforeAvatarUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB!");
            }
            return isLt2M;
        },
    }
};
</script>

<style lang="less">
    .roleForm .el-select{
        display: block;
    }
    .upload-progress{
    position: absolute;
    z-index: 99;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
}
.avatar-uploader .el-upload{
    position: relative;
    line-height: 0;
}
.avatar-uploader .avatar-uploader-icon {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: @primary-color;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
}
.avatar {
    width: 120px;
    height: 120px;
    display: block;
}
</style>


